import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Auth } from 'aws-amplify';
import { OwnerEvaluationService } from '../shared/services/owner-evaluation.service';

@Component({
  selector: 'app-property-owner',
  templateUrl: './property-owner.component.html',
  styleUrls: ['./property-owner.component.css']
})
export class PropertyOwnerComponent implements OnInit {

  public pageName: string = "Owners";
  imageBaseUrl = "https://cherymaupps3gradebookexample.s3.amazonaws.com/"

  public displayDetails: boolean; 
  public _application: any; 

  public propertiesData: any = [];
  public isLoading = true;
  public isResults: boolean = true;
  public viewValuations: boolean = true;
  // public imageBaseUrl = "https://ganisponsormarket-all-purpose.s3.amazonaws.com/";
  userGroup: any;
  state: any;
  openSuccessModal: boolean = false;
  valuationSearchText: any;
  searchText: any;
  displaySearchText: any = "";
  categories: { id: number; value: string; isSelected: boolean; }[];
  queryArr: any = [];
  owner_id: any;
  isSorting: boolean = false;
  filters: any = [];
  searching: boolean;
  resultsValue: any;
  searchResults: boolean;
  sp_application: any;

  constructor(private evaluationService: OwnerEvaluationService) { }

  ngOnInit(): void {
    this.categories = [
      { id: 1, value: 'SUBMITTED', isSelected: false },
      { id: 2, value: 'APPROVED', isSelected: false },
      { id: 3, value: 'REJECTED', isSelected: false }
    ];

    Auth.currentAuthenticatedUser()
      .then((user) => {
        this.owner_id = user.signInUserSession.accessToken.payload.sub;

        this.userGroup = user.signInUserSession.accessToken.payload['cognito:groups'][0];
        // this.getEvaluations(this.userGroup);    //getting Valuations depending on userGroup
      }, (error) => {
        console.log("authentication error", error);
      });

    setTimeout(() => {
      this.getApplicationFromDynamodb();
    }, 3000);

    this.getApplications();

  }

  getApplications() {
    this.evaluationService.onGetApplications()
      .subscribe((data) => {
        console.log('Elastic Data ==> ', data);
        this.propertiesData = data.hits.hits;
        console.log('PropertiesData ==>> ', this.propertiesData);
      })
    err => console.log('Err ==> ', err);

  }

  getApplicationFromDynamodb() {
    const obj = {
      owner_id: 'OWNER_ID-' + this.owner_id
    };

    console.log('obj ==> ', obj);

    this.evaluationService.getApplications(obj)
      .subscribe((data) => {
        console.log('Dynamo Data ==> ', data)
        this.sp_application = data[0].Items; 
      })
    err => {
      console.log('Err ==> ', err);
    }
  }

  onDisplayDetails(applicationDetails: any) {
    this.displayDetails = true; 
    this._application = applicationDetails; 
    
  }

}
